import PropTypes from "prop-types";
import { MiMenu } from "@miplatform/components";
import { Box, useTheme } from "@mui/material";
import TaskActionModal from "./TaskActionModal/TaskActionModal";
import { useTaskCardMenuViewModel } from "./useTaskCardMenuViewModel";

export function TaskCardMenu({
  closeContextMenu = () => null,
  setModalType = () => null,
  onAttemptUpdated = () => null,
  handleOpenCloseoutDrawer = () => null,
  onEmailDrawerOpen = () => null,
  onEmailModalOpen = () => null,
  updateCalendarCounts = () => null,
  setHasModalOpen = () => null,
  contextMenu = null,
  modalType = "",
  attempt = {},
  isInBucket = false,
  isCalendar = true,
  calendarSet,
}) {
  const theme = useTheme();
  const { menuOptions, MENU_LABELS, closeModal, modalTypeState } =
    useTaskCardMenuViewModel({
      attempt,
      isCalendar,
      isInBucket,
      closeContextMenu,
      handleOpenCloseoutDrawer,
      modalType,
      setModalType,
      onAttemptUpdated,
      onEmailDrawerOpen,
      setHasModalOpen,
    });

  const extraProps = isCalendar
    ? {
        condensed: true,
        closeContextMenu,
        open: contextMenu !== null,
        anchorReference: "anchorPosition",
        anchorPosition:
          contextMenu !== null
            ? {
                top: contextMenu?.mouseY,
                left: contextMenu?.mouseX,
              }
            : undefined,
        optionalElement: <span />,
      }
    : {};

  return (
    <Box>
      <MiMenu
        data={menuOptions}
        testID="task-card-menu"
        menuStyles={{ zIndex: theme.zIndex.tooltip }}
        {...extraProps}
      />
      <TaskActionModal
        openModal={modalTypeState}
        onAttemptUpdated={onAttemptUpdated}
        onEmailModalOpen={onEmailModalOpen}
        updateCalendarCounts={updateCalendarCounts}
        MENU_LABELS={MENU_LABELS}
        closeModal={closeModal}
        attempt={attempt}
        calendarSet={calendarSet}
      />
    </Box>
  );
}

TaskCardMenu.propTypes = {
  closeContextMenu: PropTypes.func,
  setModalType: PropTypes.func,
  onAttemptUpdated: PropTypes.func,
  handleOpenCloseoutDrawer: PropTypes.func,
  contextMenu: PropTypes.shape({
    mouseX: PropTypes.number,
    mouseY: PropTypes.number,
  }),
  modalType: PropTypes.string,
  attempt: PropTypes.object,
  isInBucket: PropTypes.bool,
  isCalendar: PropTypes.bool,
};
